module.exports = __webpack_public_path__ + "static/media/17990885_1834121430175845_5897502198857508124_n.736047e3.jpg";